import { render, staticRenderFns } from "./formckeditor.vue?vue&type=template&id=5d2d181e&"
import script from "./formckeditor.vue?vue&type=script&lang=js&"
export * from "./formckeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports